import React from "react";
import "./CommittedQuality.css";

export default function CommittedQuality({
  imageSrc = "/truck.JPEG",
  imageAlt = "Excavator working at a muddy job site with logs",
}) {
  return (
    <section className="cq" aria-labelledby="cq-title">
      <div className="cq__grid">
        {/* Left: framed image */}
        <div className="cq__media">
          <div className="cq__media-frame">
            <img
              src={imageSrc}
              alt={imageAlt}
              width={1280}
              height={720}
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>

        {/* Right: content */}
        <div className="cq__content">
          <p className="cq__eyebrow">Get to Know Us</p>

          <h2 id="cq-title" className="cq__title">
            Committed to only high
            <br />
            quality service
          </h2>

          <hr className="cq__rule" />

          {/* Badge list */}
          <div className="cq__badges" role="list">
            {/* Partnership & Respect */}
            <div className="cq-badge" role="listitem">
              <span className="cq-badge__icon" aria-hidden="true">
                {/* Handshake */}
                <svg viewBox="0 0 48 48">
                  <path d="M26 22l5 5a4 4 0 11-6 6l-5-5-5 5a4 4 0 11-6-6l5-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M14 23l8-8a4 4 0 015.7 0l2.3 2.3" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M6 20h8m20 0h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </span>
              <div className="cq-badge__text">
                <h3 className="cq-badge__title">Partnership That Delivers</h3>
                <p className="cq-badge__sub">Aligned with developers, municipalities &amp; GCs</p>
              </div>
            </div>

            {/* West Coast Roots & Founders */}
            <div className="cq-badge" role="listitem">
              <span className="cq-badge__icon" aria-hidden="true">
                {/* Map pin + evergreen */}
                <svg viewBox="0 0 48 48">
                  <path d="M24 8a10 10 0 0110 10c0 9-10 18-10 18S14 27 14 18A10 10 0 0124 8z" fill="none" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="24" cy="18" r="3" fill="none" stroke="currentColor" strokeWidth="2"/>
                  <path d="M32 30l-3-5-3 5h2l-2 4h3v4h3v-4h3l-2-4h2z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                </svg>
              </span>
              <div className="cq-badge__text">
                <h3 className="cq-badge__title">West Coast Roots</h3>
                <p className="cq-badge__sub">
                  Founded in 2019 by Mohamed Moalin (B.S. Civil, WSU) &amp; Greg Qualls (Local&nbsp;302)
                </p>
              </div>
            </div>
          </div>

          <hr className="cq__rule cq__rule--spaced" />

          <p className="cq__body">
            At MNG Construction LLC, we’re proud to be your trusted partner in heavy civil
            contracting. We prioritize safety, quality, efficiency, and effective management—
            treating customers, subcontractors, suppliers, and the public with the highest
            respect. With West Coast roots and decades of combined field and engineering
            experience, we provide exceptional value to developers, municipalities, and
            general contractors. Let’s build the future together.
          </p>
        </div>
      </div>
    </section>
  );
}
